import * as React from 'react';
import * as styles from './styles.css';
import { UIText1 } from '@cian/ui-kit';
import { IPriceDynamicsInfo } from './types';

export function PriceDynamicsInfo({
  averageContent,
  periodText,
  isRoomsCountAll,
  priceChangeContent,
}: IPriceDynamicsInfo) {
  return (
    <div className={styles['container']}>
      <div className={styles['item']}>
        <UIText1 color="text-secondary-default">Средняя цена за {isRoomsCountAll ? 'м²' : 'квартиру'}</UIText1>
        <div className={styles['item_info']}>{averageContent}</div>
      </div>
      <div className={styles['item']}>
        <div className={styles['subtitle']}>
          <UIText1 color="text-secondary-default">Изменение цены за {periodText}</UIText1>
        </div>
        <div className={styles['item_info']}>{priceChangeContent}</div>
      </div>
    </div>
  );
}
